import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Boxes, Download, ArrowRight, AlertCircle } from "lucide-react";
import { DashboardLayout } from "../../components/DashboardLayout";
import { MEMBER_MENU } from "../../lib/menus";
import { useAuth } from "../../context/AuthContext";
import { ProductCard } from "../../components/ProductCard";
import api from "../../lib/api";

export default function MemberDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    document.title = "Dashboard Member - DS KODE";
    api.get("/member/stats").then((r) => setStats(r.data)).catch(() => {});
    api.get("/products?sort=newest&limit=4").then((r) => setRecent(r.data.items)).catch(() => {});
  }, []);

  const cards = [
    { label: "Produk Dimiliki", value: stats?.owned_products ?? "-", icon: Boxes, cls: "bg-indigo-50 text-indigo-600" },
    { label: "Total Download", value: stats?.total_downloads ?? "-", icon: Download, cls: "bg-emerald-50 text-emerald-600" },
  ];

  return (
    <DashboardLayout title="Dashboard" menu={MEMBER_MENU} testid="member-dashboard">
      <h2 className="font-heading text-2xl font-extrabold text-slate-900">Selamat datang, {user?.name} 👋</h2>
      <p className="text-slate-500 mt-1">Kelola produk & unduhan Anda di sini.</p>

      {user?.status !== "APPROVED" && (
        <div className="mt-5 flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl p-4" data-testid="approval-banner">
          <AlertCircle className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
          <div><p className="font-semibold text-amber-800 text-sm">Menunggu Persetujuan</p><p className="text-sm text-amber-700">Akun Anda masih menunggu persetujuan admin. Anda belum dapat mengunduh produk.</p></div>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
        {cards.map((c) => (
          <div key={c.label} className="card p-5 flex items-center gap-4" data-testid={`stat-${c.label.toLowerCase().replace(/\s/g, "-")}`}>
            <span className={`grid place-items-center h-12 w-12 rounded-xl ${c.cls}`}><c.icon className="h-6 w-6" /></span>
            <div><p className="text-2xl font-extrabold font-heading text-slate-900">{c.value}</p><p className="text-sm text-slate-500">{c.label}</p></div>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between mt-10 mb-4">
        <h3 className="font-heading text-lg font-bold text-slate-900">Produk Terbaru</h3>
        <Link to="/products" className="text-sm font-semibold text-indigo-600 flex items-center gap-1">Lihat Katalog <ArrowRight className="h-4 w-4" /></Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {recent.map((p) => <ProductCard key={p.id} p={p} />)}
      </div>
    </DashboardLayout>
  );
}
